import { AdminLicensesSliceStateInterface } from 'store/reducers/adminLicenses/types';

export const initialAdminLicensesStoreState: AdminLicensesSliceStateInterface = {
  adminLicense: {
    adminLicenseData: null,
    loading: false,
  },
};
